export const updateTitle = (title: string) => {
  document.title = `${title} - Factoring Control Panel`;
};
